import cn from 'classnames';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { icons } from 'src/configs/icons';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { CMSManager } from 'src/manager/CMSManager';
import { getInfoPages } from 'src/services/cmsApi';
import { setBottomNavigation } from 'src/store/configs/actions';
import { CmsInfoPagesResponse } from 'src/types/cms/cmsPageTypes';
import { RootState } from 'src/types/store-types';
import _styles from './styles.module.scss';

type Props = {
  changeSelectedMenuItem: (menuItem: string) => void;
  selectMenuItem: string;
  openInfoAndRules: (ev: { section: string; subSection: string; subTitle?: string }) => void;
};
const StaticLists: FC<Props> = ({ changeSelectedMenuItem, selectMenuItem, openInfoAndRules }) => {
  const { t }: Translation = useTranslation();
  const { locale } = useI18n();
  const _setBottomNavigation = useConnectedAction(setBottomNavigation);
  const { bottomNavigation } = useSelector((state: RootState) => state.configs);

  const openAccountModal = (subSection: string, subTitle: string): void => {
    openInfoAndRules({ section: 'info_and_rules', subSection, subTitle });
  };

  const getStaticPageData = async (): Promise<void> => {
    try {
      const res: CmsInfoPagesResponse = await getInfoPages(locale);

      if (res?.result?.length) {
        const parsedBottomNavigation = CMSManager.inhouseCms.getInfoAndRulesData(res.result);

        _setBottomNavigation(parsedBottomNavigation);
      } else {
        _setBottomNavigation([]);
        console.error('bottom navigation from cms is not found');
      }
    } catch (error) {
      _setBottomNavigation([]);
      console.error('failed to load bottom navigation from cms', error);
    }
  };

  useEffect(() => {
    if (bottomNavigation.length === 0 && locale) {
      getStaticPageData();
    }
  }, [locale, bottomNavigation.length]);

  if (bottomNavigation.length > 0) {
    return (
      <>
        <Button
          className={cn(_styles.accordion, _styles['lg-item'], 'mobile_menu_accordion')}
          onClick={() => changeSelectedMenuItem('info_and_rules')}
          justifyContentValue="space-between"
        >
          <div>
            <span className="icon-info" />
            {t('info_and_rules')}
          </div>
          <div className={cn(_styles.arrow, { [_styles.rotateArrow]: selectMenuItem === 'info_and_rules' })}>
            <SvgIcon src={icons.arrowDown} />
          </div>
        </Button>
        <ul
          className={_styles.panel}
          style={{
            display: selectMenuItem === 'info_and_rules' ? 'block' : 'none',
          }}
        >
          {bottomNavigation?.map((page, j) => {
            if (!page?.name || !page?.title) {
              return null;
            }

            return (
              <li key={page.name || page.title || `page-${j}`} onClick={() => openAccountModal(page.name, page.title)}>
                {t(page.title)}
              </li>
            );
          })}
        </ul>
      </>
    );
  }
  return null;
};
export default StaticLists;
